import { Protocol } from '../Protocol';

export class ExptMaterialInspectionProtocol {
  public static readonly GET_EXPT_MATERIAL_BY_AREA: string = `${Protocol.YATUNG_API_ROOT}/expt/area/pass/rate`;
  public static readonly GET_EXPT_MATERIAL_BY_FACTORY: string = `${Protocol.YATUNG_API_ROOT}/expt/factory/pass/rate`;
  public static readonly GET_PAGINATION_MATERIAL_VIEW: string = `${Protocol.YATUNG_API_ROOT}/expt/factory/view`;
}
